import React from 'react';
import { useHistory } from 'react-router-dom';

import { Modal, ModalFooter, ModalPrimaryBtn, ModalSecondaryBtn } from 'components/modal/Modal';
import { Routes, getPath } from 'routes';

interface LinkBankLaterModalProps {
    isOpen?: boolean;
    onClose: () => void;
}

export const LinkBankLaterModal = (props: LinkBankLaterModalProps) => {
    const history = useHistory();

    const onLinkBankLaterClick = () => {
        history.replace(getPath(Routes.StartProgramCompleted, { status: 'link-bank-later' }));
    };

    return (
        <Modal
            title="Don't have your organization's banking information right now?"
            isOpen={props.isOpen}
            onClose={props.onClose}
        >
            <div className="text-grey-1 space-y-4">
                <p>No problem. You can still launch your fundraiser and start earning today.</p>
                <p>Please note the following details in choosing to link a bank account later:</p>
                <ul className="list-disc ml-6 leading-7 space-y-1.5">
                    <li>
                        <strong>Fewer Brands:</strong> Access to a smaller catalog of eGift cards
                        and reloadable gift cards
                    </li>
                    <li>
                        <strong>Quarterly Payouts:</strong> You&apos;ll receive earnings by cheque
                        on a quarterly basis with a minimum earnings threshold of $20, instead of
                        monthly through automatic direct deposit
                    </li>
                </ul>
                <p>
                    To access our full catalog of eGift cards and receive earnings through monthly
                    automatic direct deposit, please return to the previous screen and link your
                    organization&apos;s bank account.
                </p>
            </div>
            <ModalFooter>
                <ModalPrimaryBtn onClick={onLinkBankLaterClick}>
                    Link Bank Account Later
                </ModalPrimaryBtn>
                <ModalSecondaryBtn onClick={props.onClose}>
                    No, I can link a bank account
                </ModalSecondaryBtn>
            </ModalFooter>
        </Modal>
    );
};
